import { Locale } from 'chaika-enums';
export const planModule = {
    listOfPrograms: {
        [Locale.Ru]: `Список программ`,
        [Locale.Am]: `Ծրագրերի ցանկ`,
        [Locale.En]: `List of programs`,
        [Locale.Pt]: 'Lista de programas',
        [Locale.Ge]: `List of programs`,
    },
    planService: {
        [Locale.Ru]: `Услуга для продажи программы`,
        [Locale.Am]: `Ծրագրի վաճառքի ծառայություն`,
        [Locale.En]: `Service for selling the program`,
        [Locale.Pt]: 'Serviço para venda do programa',
        [Locale.Ge]: `Service for selling the program`,
    },
    saveProgramBeforeLinkingService: {
        [Locale.Ru]: `Сохраните программу, чтобы привязать услугу`,
        [Locale.Am]: `Պահպանեք ծրագիրը՝ ծառայությունը կցելու համար`,
        [Locale.En]: `Save the program to link a service`,
        [Locale.Pt]: 'Salve o programa para vincular um serviço',
        [Locale.Ge]: `Save the program to link a service`,
    },
    minAgeYears: {
        [Locale.Ru]: `Минимальный возраст (полных лет)`,
        [Locale.Am]: `Նվազագույն տարիք (լրացած տարիներ)`,
        [Locale.En]: `Minimum age (full years)`,
        [Locale.Pt]: 'Idade mínima (anos completos)',
        [Locale.Ge]: `Minimum age (full years)`,
    },
    maxAgeYears: {
        [Locale.Ru]: `Максимальный возраст (полных лет)`,
        [Locale.Am]: `Առավելագույն տարիք (լրացած տարիներ)`,
        [Locale.En]: `Maximum age (full years)`,
        [Locale.Pt]: 'Idade máxima (anos completos)',
        [Locale.Ge]: `Maximum age (full years)`,
    },
    ageNotLimited: {
        [Locale.Ru]: `Не ограничен`,
        [Locale.Am]: `Սահմանափակված չէ`,
        [Locale.En]: `No limit`,
        [Locale.Pt]: 'Sem limite',
        [Locale.Ge]: `No limit`,
    },
    ageRestrictionNone: {
        [Locale.Ru]: `Возраст пациентов не ограничен`,
        [Locale.Am]: `Պացիենտների տարիքը սահմանափակված չէ`,
        [Locale.En]: `Patient age is not limited`,
        [Locale.Pt]: 'Idade dos pacientes sem restrição',
        [Locale.Ge]: `Patient age is not limited`,
    },
    ageRestrictionSummaryRange: {
        [Locale.Ru]: `Для пациентов от $min до $max $unitMax включительно (младше $next $unitNext)`,
        [Locale.Am]: `$min-ից $max $unitMax ներառյալ պացիենտների համար ($next $unitNext-ից փոքր)`,
        [Locale.En]: `For patients aged $min to $max $unitMax inclusive (under $next $unitNext)`,
        [Locale.Pt]: 'Para pacientes de $min a $max $unitMax inclusive (menores de $next $unitNext)',
        [Locale.Ge]: `For patients aged $min to $max $unitMax inclusive (under $next $unitNext)`,
    },
    ageRestrictionSummaryExact: {
        [Locale.Ru]: `Для пациентов $min $unitMin (младше $next $unitNext)`,
        [Locale.Am]: `$min $unitMin պացիենտների համար ($next $unitNext-ից փոքր)`,
        [Locale.En]: `For patients aged $min $unitMin (under $next $unitNext)`,
        [Locale.Pt]: 'Para pacientes de $min $unitMin (menores de $next $unitNext)',
        [Locale.Ge]: `For patients aged $min $unitMin (under $next $unitNext)`,
    },
    ageRestrictionSummaryMin: {
        [Locale.Ru]: `Для пациентов от $min $unitMin и старше`,
        [Locale.Am]: `$min $unitMin և ավելի բարձր տարիքի պացիենտների համար`,
        [Locale.En]: `For patients aged $min $unitMin and older`,
        [Locale.Pt]: 'Para pacientes a partir de $min $unitMin',
        [Locale.Ge]: `For patients aged $min $unitMin and older`,
    },
    ageRestrictionSummaryMax: {
        [Locale.Ru]: `Для пациентов младше $next $unitNext`,
        [Locale.Am]: `$next $unitNext-ից փոքր պացիենտների համար`,
        [Locale.En]: `For patients under $next $unitNext`,
        [Locale.Pt]: 'Para pacientes menores de $next $unitNext',
        [Locale.Ge]: `For patients under $next $unitNext`,
    },
    yearGenitive: {
        [Locale.Ru]: `года`,
        [Locale.Am]: `տարի`,
        [Locale.En]: `year`,
        [Locale.Pt]: 'ano',
        [Locale.Ge]: `year`,
    },
    yearsGenitive: {
        [Locale.Ru]: `лет`,
        [Locale.Am]: `տարի`,
        [Locale.En]: `years`,
        [Locale.Pt]: 'anos',
        [Locale.Ge]: `years`,
    },
    minAgeGreaterThanMaxAge: {
        [Locale.Ru]: `Минимальный возраст больше максимального`,
        [Locale.Am]: `Նվազագույն տարիքը մեծ է առավելագույնից`,
        [Locale.En]: `Minimum age is greater than maximum age`,
        [Locale.Pt]: 'A idade mínima é maior que a máxima',
        [Locale.Ge]: `Minimum age is greater than maximum age`,
    },
    payerType: {
        [Locale.Ru]: `Тип плательщика`,
        [Locale.Am]: `Վճարողի տեսակ`,
        [Locale.En]: `Payer type`,
        [Locale.Pt]: 'Tipo de pagador',
        [Locale.Ge]: `Payer type`,
    },
    payer: {
        [Locale.Ru]: `Плательщик`,
        [Locale.Am]: `Վճարող`,
        [Locale.En]: `Payer`,
        [Locale.Pt]: 'Pagador',
        [Locale.Ge]: `Payer`,
    },
    payerLegalEntity: {
        [Locale.Ru]: `Плательщик юр. лицо`,
        [Locale.Am]: `Վճարողը՝ իրավաբանական անձ`,
        [Locale.En]: `Payer legal entity`,
        [Locale.Pt]: 'Pessoa jurídica pagadora',
        [Locale.Ge]: `Payer legal entity`,
    },
    payerIndividual: {
        [Locale.Ru]: `Плательщик физ. лицо`,
        [Locale.Am]: `Վճարողը՝ ֆիզիկական անձ`,
        [Locale.En]: `Payer is an individual`,
        [Locale.Pt]: 'O pagador é um indivíduo',
        [Locale.Ge]: `Payer is an individual`,
    },
    validityPeriod: {
        [Locale.Ru]: `Срок действия`,
        [Locale.Am]: `Գործողության ժամկետ`,
        [Locale.En]: `Validity period`,
        [Locale.Pt]: 'Período de validade',
        [Locale.Ge]: `Validity period`,
    },
    programSettings: {
        [Locale.Ru]: `Настройки программ`,
        [Locale.Am]: `Ծրագրերի կարգավորումներ`,
        [Locale.En]: `Program settings`,
        [Locale.Pt]: 'Configurações do programa',
        [Locale.Ge]: `Program settings`,
    },
    openSubscriptions: {
        [Locale.Ru]: `Открыть подписки`,
        [Locale.Am]: `Բացել բաժանորդագրությունները`,
        [Locale.En]: `Open subscriptions`,
        [Locale.Pt]: 'Assinaturas abertas',
        [Locale.Ge]: `Open subscriptions`,
    },
    approve: {
        [Locale.Ru]: `Согласовать`,
        [Locale.Am]: `Համաձայնեցնել`,
        [Locale.En]: `Approve`,
        [Locale.Pt]: 'Aprovar',
        [Locale.Ge]: `Approve`,
    },
    notIncluded: {
        [Locale.Ru]: `Не входит`,
        [Locale.Am]: `Ներառված չէ`,
        [Locale.En]: `Not included`,
        [Locale.Pt]: 'Não incluído',
        [Locale.Ge]: `Not included`,
    },
    included: {
        [Locale.Ru]: `Входит`,
        [Locale.Am]: `Ներառված է`,
        [Locale.En]: `Included`,
        [Locale.Pt]: 'Incluído',
        [Locale.Ge]: `Included`,
    },
    coverageAmount: {
        [Locale.Ru]: `Сумма покрытия`,
        [Locale.Am]: `Ծածկույթի գումար`,
        [Locale.En]: `Coverage amount`,
        [Locale.Pt]: 'Valor da cobertura',
        [Locale.Ge]: `Coverage amount`,
    },
    coverageEmountExceeded: {
        [Locale.Ru]: `Превышена сумма покрытия`,
        [Locale.Am]: `Ծածկույթի գումարը գերազանցված է`,
        [Locale.En]: `Coverage amount exceeded`,
        [Locale.Pt]: 'Valor de cobertura excedido',
        [Locale.Ge]: `Coverage amount exceeded`,
    },
    openConditions: {
        [Locale.Ru]: 'Открыть условия',
        [Locale.Am]: 'Բացել պայմանները',
        [Locale.En]: 'Open conditions',
        [Locale.Pt]: 'Condições abertas',
        [Locale.Ge]: 'Open conditions',
    },
    insurance: {
        [Locale.Ru]: 'Страховка',
        [Locale.Am]: 'Ապահովագրություն',
        [Locale.En]: 'Insurance',
        [Locale.Pt]: 'Seguro',
        [Locale.Ge]: 'Insurance',
    },
    GPPlusFull: {
        [Locale.Ru]: `Гарантийное письмо плюс`,
        [Locale.Am]: `Երաշխիքային նամակ պլյուս`,
        [Locale.En]: `Letter of guarantee plus`,
        [Locale.Pt]: 'Carta de garantia mais',
        [Locale.Ge]: `Letter of guarantee plus`,
    },
    GPPlus: {
        [Locale.Ru]: `ГП плюс`,
        [Locale.Am]: `ԵՆ պլյուս`,
        [Locale.En]: `GP plus`,
        [Locale.Pt]: 'GP mais',
        [Locale.Ge]: `GP plus`,
    },
    programType: {
        [Locale.Ru]: `Тип программы`,
        [Locale.Am]: `Ծրագրի տեսակ`,
        [Locale.En]: `Program type`,
        [Locale.Pt]: 'Tipo de programa',
        [Locale.Ge]: `Program type`,
    },
    GPFull: {
        [Locale.Ru]: `Гарантийное письмо`,
        [Locale.Am]: `Երաշխիքային նամակ`,
        [Locale.En]: `Letter of guarantee`,
        [Locale.Pt]: 'Carta de garantia',
        [Locale.Ge]: `Letter of guarantee`,
    },
    waitingGP: {
        [Locale.Ru]: `Ожидание ГП`,
        [Locale.Am]: `Երաշխիքային նամակի սպասում`,
        [Locale.En]: `Waiting for GP`,
        [Locale.Pt]: 'Esperando pelo GP',
        [Locale.Ge]: `Waiting for GP`,
    },
    checkup: {
        [Locale.Ru]: `Чекап`,
        [Locale.Am]: `Չեքափ`,
        [Locale.En]: `Checkup`,
        [Locale.Pt]: 'Checar',
        [Locale.Ge]: `Checkup`,
    },
    legalEntityShort: {
        [Locale.Ru]: `Юр лицо`,
        [Locale.Am]: `Իրավաբանական անձ`,
        [Locale.En]: `Legal entity`,
        [Locale.Pt]: 'Pessoa jurídica',
        [Locale.Ge]: `Legal entity`,
    },
    individual: {
        [Locale.Ru]: `Физ лицо`,
        [Locale.Am]: `Ֆիզիկական անձ`,
        [Locale.En]: `Individual`,
        [Locale.Pt]: 'Individual',
        [Locale.Ge]: `Individual`,
    },
    contractNumber: {
        [Locale.Ru]: `Номер договора`,
        [Locale.Am]: `Պայմանագրի համար`,
        [Locale.En]: `Contract number`,
        [Locale.Pt]: 'Número do contrato',
        [Locale.Ge]: 'ხელშეკრულების ნომერი',
    },
    baseShare: {
        [Locale.Ru]: `Базовая доля`,
        [Locale.Am]: `Բազային բաժին`,
        [Locale.En]: `Basic share`,
        [Locale.Pt]: 'Compartilhamento básico',
        [Locale.Ge]: `Basic share`,
    },
    baseDiscount: {
        [Locale.Ru]: `Базовая скидка`,
        [Locale.Am]: `Բազային զեղչ`,
        [Locale.En]: `Basic discount`,
        [Locale.Pt]: 'Desconto básico',
        [Locale.Ge]: `Basic discount`,
    },
    toPlans: {
        [Locale.Ru]: `К планам`,
        [Locale.Am]: `Դեպի պլաններ`,
        [Locale.En]: `To plans`,
        [Locale.Pt]: 'Para planos',
        [Locale.Ge]: `To plans`,
    },
    loadIncludeService: {
        [Locale.Ru]: `Загрузить включаемые услуги`,
        [Locale.Am]: `Վերբեռնել ներառվող ծառայությունները`,
        [Locale.En]: `Load included services`,
        [Locale.Pt]: 'Carregar serviços incluídos',
        [Locale.Ge]: `Load included services`,
    },
    errorOnSaving: {
        [Locale.Ru]: `При сохранении возникла ошибка`,
        [Locale.Am]: `Պահպանելիս առաջացել է սխալ`,
        [Locale.En]: `An error occurred while saving`,
        [Locale.Pt]: 'Ocorreu um erro ao salvar',
        [Locale.Ge]: `An error occurred while saving`,
    },
    share: {
        [Locale.Ru]: `Доля`,
        [Locale.Am]: `Բաժին`,
        [Locale.En]: `Share`,
        [Locale.Pt]: 'Compartilhar',
        [Locale.Ge]: `Share`,
    },
    limit: {
        [Locale.Ru]: `Лимит`,
        [Locale.Am]: `Սահմանաչափ`,
        [Locale.En]: `Limit`,
        [Locale.Pt]: 'Limite',
        [Locale.Ge]: `Limit`,
    },
    agreement: {
        [Locale.Ru]: `Согласование`,
        [Locale.Am]: `Համաձայնեցում`,
        [Locale.En]: `Agreement`,
        [Locale.Pt]: `Acordo`,
        [Locale.Ge]: `Agreement`,
    },
    withoutApproval: {
        [Locale.Ru]: `Без согласования`,
        [Locale.Am]: `Առանց համաձայնեցման`,
        [Locale.En]: `Without approval`,
        [Locale.Pt]: 'Sem aprovação',
        [Locale.Ge]: `Without approval`,
    },
    coordinationRequired: {
        [Locale.Ru]: `Необходимо согласование`,
        [Locale.Am]: `Անհրաժեշտ է համաձայնեցում`,
        [Locale.En]: `Coordination required`,
        [Locale.Pt]: 'Coordenação necessária',
        [Locale.Ge]: `Coordination required`,
    },
    notIncludedInInsurance: {
        [Locale.Ru]: `Не входит в страховку`,
        [Locale.Am]: `Ներառված չէ ապահովագրության մեջ`,
        [Locale.En]: `Not included in insurance`,
        [Locale.Pt]: 'Não incluído no seguro',
        [Locale.Ge]: `Not included in insurance`,
    },
    versionStartDate: {
        [Locale.Ru]: `Дата начала версии`,
        [Locale.Am]: `Տարբերակի սկզբի ամսաթիվ`,
        [Locale.En]: `Version start date`,
        [Locale.Pt]: 'Data de início da versão',
        [Locale.Ge]: `Version start date`,
    },
    serviceLoadFromCSV: {
        [Locale.Ru]: `Услуги успешно загружены из CSV файла`,
        [Locale.Am]: `Ծառայությունները հաջողությամբ բեռնվել են CSV ֆայլից`,
        [Locale.En]: `Services successfully loaded from CSV file`,
        [Locale.Pt]: 'Serviços carregados com sucesso do arquivo CSV',
        [Locale.Ge]: `Services successfully loaded from CSV file`,
    },
    versionActionStartDate: {
        [Locale.Ru]: `Дата начала действия версии`,
        [Locale.Am]: `Տարբերակի գործողության սկզբի ամսաթիվ`,
        [Locale.En]: `Version start date`,
        [Locale.Pt]: 'Data de início da versão',
        [Locale.Ge]: `Version start date`,
    },
    costLimitation: {
        [Locale.Ru]: `Ограничение стоимости`,
        [Locale.Am]: `Արժեքի սահմանափակում`,
        [Locale.En]: `Cost limitation`,
        [Locale.Pt]: 'Limitação de custos',
        [Locale.Ge]: `Cost limitation`,
    },
    planCost: {
        [Locale.Ru]: `Стоимость подписки`,
        [Locale.Am]: `Բաժանորդագրության արժեք`,
        [Locale.En]: `Subscription cost`,
        [Locale.Pt]: 'Custo da assinatura',
        [Locale.Ge]: `Subscription cost`,
    },
    costOfPlan: {
        [Locale.Ru]: `Стоимость плана`,
        [Locale.Am]: `Պլանի արժեք`,
        [Locale.En]: `Plan cost`,
        [Locale.Pt]: 'Custo do plano',
        [Locale.Ge]: `Plan cost`,
    },
    includedSets: {
        [Locale.Ru]: `Включаемые наборы`,
        [Locale.Am]: `Ներառվող հավաքածուներ`,
        [Locale.En]: `Included sets`,
        [Locale.Pt]: 'Conjuntos incluídos',
        [Locale.Ge]: `Included sets`,
    },
    includedServices: {
        [Locale.Ru]: `Включаемые услуги`,
        [Locale.Am]: `Ներառվող ծառայություններ`,
        [Locale.En]: `Included services`,
        [Locale.Pt]: 'Serviços incluídos',
        [Locale.Ge]: `Included services`,
    },
    exclusionSets: {
        [Locale.Ru]: `Исключаемые наборы`,
        [Locale.Am]: `Բացառվող հավաքածուներ`,
        [Locale.En]: `Exclusion sets`,
        [Locale.Pt]: 'Conjuntos de exclusão',
        [Locale.Ge]: `Exclusion sets`,
    },
    wrongStartVersionText: {
        [Locale.Ru]: `Дата начала версии должна быть в будущем`,
        [Locale.Am]: `Տարբերակի սկզբի ամսաթիվը պետք է լինի ապագայում`,
        [Locale.En]: `The start date of the version must be in the future`,
        [Locale.Pt]: 'A data de início da versão deve ser no futuro',
        [Locale.Ge]: `The start date of the version must be in the future`,
    },
    toProgram: {
        [Locale.Ru]: `К программе`,
        [Locale.Am]: `Դեպի ծրագիր`,
        [Locale.En]: `To the program`,
        [Locale.Pt]: 'Para o programa',
        [Locale.Ge]: `To the program`,
    },
    subscriptionsToTheProgram: {
        [Locale.Ru]: `Подписки на программу:`,
        [Locale.Am]: `Ծրագրի բաժանորդագրություններ՝`,
        [Locale.En]: `Subscriptions to the program:`,
        [Locale.Pt]: 'Assinaturas do programa:',
        [Locale.Ge]: `Subscriptions to the program:`,
    },
    edsPluginError: {
        [Locale.Ru]: 'Проблемы с плагином Крипто Про, попробуйте подписать еще раз',
        [Locale.Am]: 'Կրիպտո Պրո փլագինի հետ կապված խնդիրներ, փորձեք կրկին ստորագրել',
        [Locale.En]: 'Problems with the Crypto Pro plugin, try signing again',
        [Locale.Pt]: 'Problemas com o plugin Crypto Pro, tente assinar novamente',
        [Locale.Ge]: 'Problems with the Crypto Pro plugin, try signing again',
    },
    allServiceIncluded: {
        [Locale.Ru]: `Включает все услуги`,
        [Locale.Am]: `Ներառում է բոլոր ծառայությունները`,
        [Locale.En]: `Includes all services`,
        [Locale.Pt]: 'Inclui todos os serviços',
        [Locale.Ge]: `Includes all services`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
